module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABZElEQVQ4T6WTL4sCURTFz3V2xTYarEarYlAmCH4DwWTxAwiG2VVEDAqGgS27Y1I0WLUIBotNLFM0zVcYFJPF4IxwFx+7izL+Ydabz/m9+y7nkCzLH0T0RkSv8DDM7DDzFwWDQYeIXjx4/6TMfKRQKMT/Mf96rgKSySSazSYSiQR2ux1GoxE0TYNt2663XIBUKoXJZAK/338hns1myOfzjwHT6RSKoqDf76PVaiEajWI4HCIcDiObzWKxWFxAXBus12v4fD5EIhEcDgchrtfrqFQqAqjr+n3AarUS5lgsBsuyhLjdbqNQKKBYLIp7nI9rA1VV0Wg0YJomOp2O+EKpVBLHjMfj2O/39wGBQACGYYgtzqdcLmMwGDw+4kmRTqcxHo8hSZIwzOdz5HI5MLsjczNI1WoVtVoNm80GmUwG2+32at5uAogI3W4XvV4Py+XyZlifj/KTZXLop87vXht5aiIzf34Dfj6NKiIeFmIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/about_mobile/14.png
// module id = BBo0
// module chunks = 1